import clsx from 'clsx';

import { virtualFocus } from './virtualFocus.sty.js';

/**
 * Returns a `className` string that includes the fade-out transition and,
 * when `isFocused` is true, the matching virtual-focus variant.
 *
 * Spread the result onto the component:
 * ```tsx
 * <Flex {...getVirtualFocusStyles(isFocused, 'neutral')} />
 * ```
 *
 * @internal
 */
export function getVirtualFocusStyles(
  isFocused: boolean,
  variant: 'neutral' | 'primary' = 'neutral',
): { className: string } {
  return {
    className: clsx(isFocused && virtualFocus[variant]),
  };
}
